import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '../store/index'

// 创建axios实例
const service = axios.create({
  // baseURL: "https://testa.soujingpin.com/",
  baseURL: "https://ipa.soujingpin.com/",
  timeout: 15000   // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // console.log(config)
  // console.log(config.url)
  // 给当前请求设置请求头
  if (config.url == '/order/orderSubmitBuy' || config.url == '/order/orderSubmitCart') {
    config.headers = {
      "Content-Type": "application/json"
    }
  } else {
    if (config.method == 'get') {
      config.data = true;
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    if (config.method == 'post') {
      config.data = true;
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  }
  // 让当前请求携带token
  let AUTH_TOKEN = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : ""
  // console.log(AUTH_TOKEN)
  config.headers['Authorization'] = "Bearer " + AUTH_TOKEN
  return config
}, error => {
  // Do something with request error
  // for debug
  // console.log(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    // console.log(response)
    const res = response.data
    if (res.code !== 200) {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 3 * 1000
      // })
      // 401:未登录;
      // if (res.code === 401 || res.code === 403) {
      //   MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push({
      //       path: "/"
      //     });
      //   }).catch(() => {
      //     Message({
      //       type: 'warning',
      //       message: '取消登录'
      //     })
      //   })
      // }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    // for debug
    // console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service